import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { USER_TEAM } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const submitUserTeamFilterData = async (data = array()) => {
  try {
    const response = await POST(USER_TEAM.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchUserTeamTableAndFilterSchema = async (data = array()) => {
  try {
    const response = await GET(USER_TEAM.GET_TEAM_SCHEMA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addUserTeam = async (data = array()) => {
  try {
    const response = await POST(USER_TEAM.GET_TEAM_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateUserTeam = async (id, data = array()) => {
  try {
    const url = `${USER_TEAM.GET_TEAM_LIST}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getUserTeamDataById = async (id = "") => {
  try {
    const url = id ? `${USER_TEAM.GET_TEAM_LIST}/${id}` : `${USER_TEAM.GET_TEAM_LIST}`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
